import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { AssetFragment } from '@app-graphql/schema'

@Component({
    selector: 'app-assets',
    templateUrl: './assets.component.html',
    styleUrls: ['./assets.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AssetsComponent {
    @Input()
    public assets: AssetFragment[]
}
